export default class WebViewServices {
  static nativeSocialLogin = ({
    redirectUrl = '',
    socialAuthProvider = '',
  }) => {
    if (!WebViewServices.isReactNative()) return;

    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        type: 'SOCIAL_LOGIN',
        data: { redirectUrl, socialAuthProvider },
      }),
    );
  };

  static isReactNative = () => {
    if (typeof window === 'undefined') return false;

    if (!window) return false;

    return !!window.ReactNativeWebView;
  };
}
